// extracted by mini-css-extract-plugin
export default {"navbar-wrapper":"localNavbar_navbar-wrapper__zDLfr","navbar-inner":"localNavbar_navbar-inner__mmto3","navbar-logo":"localNavbar_navbar-logo__12ALD"};